import { cva } from 'class-variance-authority';

export const badgeVariants = cva(
  // Base styles
  [
    'inline-flex',
    'items-center',
    'gap-1.5',
    'rounded-full',
    'font-medium',
    'transition-colors',
    'duration-200',
  ],
  {
    variants: {
      variant: {
        default: ['bg-gray-100', 'dark:bg-slate-700', 'text-gray-800', 'dark:text-slate-200'],
        primary: ['bg-teal-100', 'dark:bg-teal-900', 'text-teal-800', 'dark:text-teal-200'],
        secondary: [
          'bg-violet-100',
          'dark:bg-violet-900',
          'text-violet-800',
          'dark:text-violet-200',
        ],
        success: ['bg-green-100', 'dark:bg-green-900', 'text-green-800', 'dark:text-green-200'],
        warning: ['bg-amber-100', 'dark:bg-amber-900', 'text-amber-800', 'dark:text-amber-200'],
        error: ['bg-red-100', 'dark:bg-red-900', 'text-red-800', 'dark:text-red-200'],
        info: ['bg-blue-100', 'dark:bg-blue-900', 'text-blue-800', 'dark:text-blue-200'],
      },
      size: {
        sm: ['text-xs', 'px-2', 'py-0.5'],
        md: ['text-sm', 'px-2.5', 'py-0.5'],
        lg: ['text-base', 'px-3', 'py-1'],
      },
    },
    defaultVariants: {
      variant: 'default',
      size: 'md',
    },
  }
);

export const badgeDotVariants = cva(['rounded-full', 'flex-shrink-0'], {
  variants: {
    variant: {
      default: ['bg-gray-500', 'dark:bg-slate-400'],
      primary: ['bg-teal-600', 'dark:bg-teal-400'],
      secondary: ['bg-violet-600', 'dark:bg-violet-400'],
      success: ['bg-green-600', 'dark:bg-green-400'],
      warning: ['bg-amber-600', 'dark:bg-amber-400'],
      error: ['bg-red-600', 'dark:bg-red-400'],
      info: ['bg-blue-600', 'dark:bg-blue-400'],
    },
    size: {
      sm: ['w-1.5', 'h-1.5'],
      md: ['w-2', 'h-2'],
      lg: ['w-2.5', 'h-2.5'],
    },
  },
  defaultVariants: {
    variant: 'default',
    size: 'md',
  },
});

export const badgeDismissVariants = cva(
  [
    'inline-flex',
    'items-center',
    'justify-center',
    'rounded-full',
    'hover:bg-black/10',
    'dark:hover:bg-white/10',
    'focus:outline-none',
    'focus:ring-2',
    'focus:ring-offset-1',
    'transition-colors',
    'duration-200',
    'cursor-pointer',
    'flex-shrink-0',
  ],
  {
    variants: {
      variant: {
        default: [
          'text-gray-600',
          'dark:text-slate-300',
          'hover:text-gray-800',
          'dark:hover:text-slate-100',
          'focus:ring-gray-400',
        ],
        primary: [
          'text-teal-600',
          'dark:text-teal-300',
          'hover:text-teal-800',
          'dark:hover:text-teal-100',
          'focus:ring-teal-400',
        ],
        secondary: [
          'text-violet-600',
          'dark:text-violet-300',
          'hover:text-violet-800',
          'dark:hover:text-violet-100',
          'focus:ring-violet-400',
        ],
        success: [
          'text-green-600',
          'dark:text-green-300',
          'hover:text-green-800',
          'dark:hover:text-green-100',
          'focus:ring-green-400',
        ],
        warning: [
          'text-amber-600',
          'dark:text-amber-300',
          'hover:text-amber-800',
          'dark:hover:text-amber-100',
          'focus:ring-amber-400',
        ],
        error: [
          'text-red-600',
          'dark:text-red-300',
          'hover:text-red-800',
          'dark:hover:text-red-100',
          'focus:ring-red-400',
        ],
        info: [
          'text-blue-600',
          'dark:text-blue-300',
          'hover:text-blue-800',
          'dark:hover:text-blue-100',
          'focus:ring-blue-400',
        ],
      },
      size: {
        sm: ['w-3.5', 'h-3.5', '-mr-0.5'],
        md: ['w-4', 'h-4', '-mr-0.5'],
        lg: ['w-5', 'h-5', '-mr-1'],
      },
    },
    defaultVariants: {
      variant: 'default',
      size: 'md',
    },
  }
);
